// extracted by mini-css-extract-plugin
export default {"sub-title":"styles_sub-title__3L0Vn","row":"styles_row__JKZvJ","label":"styles_label__oXFia"};